// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tree-container .team-tree{width:100%;overflow:scroll;max-height:700px;padding-bottom:90px;-ms-overflow-style:none}.tree-container ::-webkit-scrollbar{-webkit-appearance:none;width:0;height:23px}.tree-container ::-webkit-scrollbar-thumb{border-radius:10px;background-color:#e8e8e8;-webkit-box-shadow:0 0 1px hsla(0,0%,100%,.5)}.tree-container .action-buttons{text-align:right;margin:0px 40px}", ""]);
// Exports
module.exports = exports;
